export default "__VITE_ASSET__KgXdvv23__"